import { CmpEventKindEnum } from "../../../../../graphql/types";

/**
 * CMP Dashboard (15) CES:1684-1692 eventTitleList (Monday EV15-9, Moeen Q10):
 * the chamber's previous non-community event names, newest start first, no
 * duplicates. The current event is not its own suggestion.
 */
export const getPreviousEventTitles = (
  events: ReadonlyArray<{ id: string; title: string; startAtUtcMilli: number; eventKind?: CmpEventKindEnum | null }>,
  currentEventId?: string | null,
): string[] => {
  const seen = new Set<string>();
  return [...events]
    .filter((row) => row.eventKind !== CmpEventKindEnum.Community && row.id !== currentEventId)
    .sort((first, second) => second.startAtUtcMilli - first.startAtUtcMilli)
    .map((row) => row.title.trim())
    .filter((title) => {
      const key = title.toLowerCase();
      if (!title || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};
